import 'lib/shopify'
import 'component/_adaptive-image'
import 'component/_broadcast'
import 'component/_columns'
import 'component/_slider'
import 'component/_tooltip'
import 'component/_product-card'
import 'component/_modal'
import 'component/_details-modal'
import 'component/_header'
import 'component/_sticky-header'
import 'component/_localization-form'
import 'component/_focus-trap'
import 'component/_input-wrapper'
import 'component/_checkbox-wrapper'
import 'component/_custom-select'

import { importOnIntersection, lowPriority } from 'lib/performance'
import { VIEW_CART_PARAM } from 'constants'
import { callOnReady, initAnchor } from 'utils/gw'
import { toggleCart } from 'utils/shopify'
import { NostoHelper } from 'helpers/nosto'
import freeShippingManager from 'utils/free-shipping-threshold'
import DynamicStickyElement from 'lib/dynamic-sticky-element'
import 'vendor/lit'

window.remBase = parseInt(getComputedStyle(document.documentElement).getPropertyValue('font-size'), 10)

// iOS input zoom fix
if (navigator.userAgent.indexOf('iPhone') > -1) {
  document
    .querySelector('[name=viewport]')
    .setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
}

const searchParams = new URLSearchParams(window.location.search)
const loadScripts = searchParams.has('loadscripts') && searchParams.get('loadscripts') !== 'false'

callOnReady(() => {
  // TODO: Probably remove this
  // window.intersectionImports.forEach((entry) => {
  //   importOnIntersection(...entry)
  // })

  const intersectionImportElements = document.querySelectorAll('[data-intersection-import]')
  intersectionImportElements.forEach(element => {
    const { script, offset } = element.dataset
    const intersection = element.hasAttribute('data-intersection')
    const loadOnIdle = intersection ? element.dataset.idle : true
    // console.log(
    //   'importOnIntersection',
    //   script,
    //   intersection,
    //   intersection ? element : false
    // )
    console.log('IMPORTING ON INTERSECTION', script)
    importOnIntersection(script, intersection ? element : false, {
      offset,
      loadOnIdle,
      instant: loadScripts,
    })
  })

  if (searchParams.has(VIEW_CART_PARAM) && searchParams.get(VIEW_CART_PARAM) !== 'false') {
    toggleCart(true)
  }

  document.querySelectorAll(`a[href^="#"], a[href^="${window.location.pathname}#"]`).forEach(initAnchor)

  if (Shopify.currency.active !== 'USD') {
    const pricesForConversion = [...document.querySelectorAll('[data-price-for-conversion]')]
    for (const priceEl of pricesForConversion) {
      const priceUSD = priceEl.dataset.priceForConversion
      const price = priceUSD * Shopify.currency.rate
      priceEl.innerHTML = Shopify.formatMoney(price * 100)
    }
  }

  // Initialize free shipping threshold manager with GlobalE API
  if (window.Shopify?.country !== 'US') {
    freeShippingManager.init().catch(error => {
      console.error('Failed to initialize free shipping manager:', error)
    })
  }
})

class DelayedScript extends HTMLElement {
  done = false

  constructor() {
    super()
  }

  connectedCallback() {
    this.load()
  }

  get src() {
    return this.getAttribute('src') ?? this.textContent.trim()
  }

  get delay() {
    return parseInt(this.getAttribute('delay') ?? 4, 10)
  }

  async load() {
    if (this.done) return

    const callback = async () => await import(this.src)

    if (loadScripts) {
      callback()
    } else {
      lowPriority(callback, this.delay)
    }

    this.done = true
  }
}
customElements.define('delayed-script', DelayedScript)

new NostoHelper()



// Initialize dynamic sticky element
new DynamicStickyElement()
